module.exports = __webpack_public_path__ + "static/media/5.8.4f1712d6.png";